import { render, staticRenderFns } from "./eventCard.vue?vue&type=template&id=d1b1bc0c&scoped=true&"
import script from "./eventCard.vue?vue&type=script&lang=js&"
export * from "./eventCard.vue?vue&type=script&lang=js&"
import style0 from "./eventCard.vue?vue&type=style&index=0&id=d1b1bc0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b1bc0c",
  null
  
)

export default component.exports